import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { callOnce } from "../../../../utils";
import { ymPushEvent, ymPushParams } from "../../../../utils/ym";
var YM_COUNTER = 28573041;
var SUBSCRIPTION_SUCCESS = 'SubscriptionSuccess';
var wrapSubscribeEvent = function wrapSubscribeEvent(event) {
  return {
    form_name: {
      subscription: {
        footer: _defineProperty({}, event, window.location.pathname)
      }
    }
  };
};
export var sendYmOnSubscribeView = callOnce(function () {
  ymPushParams(wrapSubscribeEvent('view'));
});
export var sendYmOnSubscribeSuccess = function sendYmOnSubscribeSuccess() {
  ymPushParams(wrapSubscribeEvent('success'));
  ymPushEvent(SUBSCRIPTION_SUCCESS);
  ymPushEvent(SUBSCRIPTION_SUCCESS, '', YM_COUNTER);
};